import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/auth");
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        // Preserve original path (e.g. /invite/:token) so deep-links survive OAuth
        const target = window.location.pathname && window.location.pathname !== "/" ? window.location.pathname : "/dashboard";
        window.history.replaceState(null, "", target);
        toast.success(`Welcome, ${data.user.name}`);
        navigate(target, { replace: true, state: { user: data.user } });
      } catch {
        toast.error("Google sign-in failed");
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0D1117] grid place-items-center">
      <div className="text-xs uppercase tracking-[0.25em] text-gray-500" data-testid="oauth-loading">
        Completing sign-in…
      </div>
    </div>
  );
};

export default AuthCallback;
